<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To CA, <br/>who waited until I was ready <br/>and SEG, <br/>who waited until I was almost ready.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM.vue?68fe590b